import React from 'react';
import {formatMarketMoney,getMarket} from '../utils/market';
import { getBusinessImage, getBusinessName, getBusinessLocation, getBusinessDescription, getRatingInfo } from './BusinessResultCard';
import '../styles/searchResultsV2.css';

export default function SearchBusinessCard({ biz, onOpenBusiness, onOpenBooking }) {
  const name = getBusinessName(biz);
  const rating = getRatingInfo(biz);
  const category = biz.businessTypeLabel || ({ beauty: 'Belleza y barberías', wellness: 'Bienestar', events: 'Eventos', fitness: 'Fitness' }[biz.type || biz.businessType]) || '';
  const matched = biz.__matchedServices?.[0];
  return <article className="search-business">
    <button className="search-business-image" type="button" onClick={onOpenBusiness} aria-label={`Ver ${name}`}>
      <img src={getBusinessImage(biz)} alt="" loading="lazy" onError={e => { e.currentTarget.style.display = 'none'; }} />
    </button>
    <div className="search-business-content">
      {category && <span className="search-business-category">{category}</span>}
      <h2><button type="button" onClick={onOpenBusiness}>{name}</button></h2>
      <p className="search-business-location">{getBusinessLocation(biz)}{rating.hasRating && <span> · ★ {rating.label} ({rating.reviews})</span>}</p>
      <p className="search-business-description">{getBusinessDescription(biz)}</p>
      {matched && <p className="search-business-match">{matched.name || matched.title}{typeof matched.price === 'number' && matched.price >= 0 ? ` · Desde ${formatMarketMoney(matched.price,matched.currency || biz.currency || getMarket(biz.countryCode).currency,biz.locale || getMarket(biz.countryCode).locale)}` : ''}</p>}
    </div>
    <button className="search-business-action" type="button" onClick={onOpenBooking}>Ver servicios <span aria-hidden="true">→</span></button>
  </article>;
}
